<template>
  <div class="coach-court-list">
    <ul class="nav">
      <li>
        <router-link to="/user/user-bookings">Upcoming</router-link>
      </li>
      <li>
        <router-link to="/user/user-complete">Completed</router-link>
      </li>
      <li><router-link to="/user/user-ongoing">On Going</router-link></li>
      <li>
        <router-link to="/user/user-cancelled">Cancelled</router-link>
      </li>
    </ul>
  </div>
</template>
